import React, { useState, useEffect } from "react";
import {connect, useSelector} from "react-redux";
import { X, Megaphone, Send, Eye } from "lucide-react";
import Swal from "sweetalert2";
import "./Annoncemodal.css";

import {
    sendOfferToChasseursRequest,
    sendOfferToPartenairesRequest,
    clearRecrutementEmailState,
} from "../../../../redux/actions/demandesRecrutementActions";

// Données statiques temporaires
const CHASSEURS_DATA = [
    { id: 1, nom: "RecrutPro Consulting", logo: "RC" },
    { id: 2, nom: "TalentSearch Partners", logo: "TS" },
    { id: 3, nom: "Executive Solutions", logo: "ES" },
];

const ECOLES_DATA = [
    { id: 1, nom: "Université Mohammed V", logo: "UM5" },
    { id: 2, nom: "ENSAM Casablanca", logo: "ENSAM" },
    { id: 3, nom: "ISCAE Business School", logo: "ISCAE" },
];

function AnnonceModal({
                          open,
                          onClose,
                          demande,
                          sendOfferToChasseurs,
                          sendOfferToPartenaires,
                          sendingOfferToChasseurs,
                          sendingOfferToPartenaires,
                          sendOfferSuccess,
                          sendOfferError,
                          clearRecrutementEmailState,
                      }) {
    const [activeTab, setActiveTab] = useState(0); // 0: Générer, 1: Publier, 2: Chasseurs, 3: Écoles

    const safeDemande = demande || {};

    const [annonceText, setAnnonceText] = useState("");
    const [platforms, setPlatforms] = useState({
        linkedin: false,
        rekrute: false,
        emploi: false,
    });

    const [dateDebut, setDateDebut] = useState("");
    const [dateFin, setDateFin] = useState("");

    const [selectedChasseurs, setSelectedChasseurs] = useState([]);
    const [selectedEcoles, setSelectedEcoles] = useState([]);

    const [dateLimiteOffre, setDateLimiteOffre] = useState("");
    const [dateEnvoiEmail, setDateEnvoiEmail] = useState(
        new Date().toISOString().slice(0, 10)
    );

    const { chasseurs, domaines, loading: loadingChasseurs } = useSelector((s) => s.chasseurs);
    const { partenairesAcademiques: partenaires, loading: loadingPartenaires } = useSelector(
        (s) => s.partenairesAcademiques
    );
    console.log("partenaires",partenaires)
    const buildInitials = (name) => {
        if (!name) return "NA";
        return name
            .split(" ")
            .filter(Boolean)
            .slice(0, 2)
            .map((part) => part[0]?.toUpperCase())
            .join("");
    };
    // Scroll lock
    useEffect(() => {
        if (!open) return;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "unset";
        };
    }, [open]);

    useEffect(() => {
        if (sendOfferSuccess) {
            Swal.fire({
                icon: "success",
                text: sendOfferSuccess,
                timer: 2200,
                showConfirmButton: false,
            });

            setSelectedChasseurs([]);
            setSelectedEcoles([]);
            clearRecrutementEmailState();
        }
    }, [sendOfferSuccess, clearRecrutementEmailState]);

    useEffect(() => {
        if (sendOfferError) {
            Swal.fire({
                icon: "error",
                text: sendOfferError,
                timer: 2800,
                showConfirmButton: false,
            });

            const timer = setTimeout(() => {
                clearRecrutementEmailState();
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [sendOfferError, clearRecrutementEmailState]);

    // Générer l'annonce
    const generateAnnonce = () => {
        const text = `🎯 Offre d'emploi : ${safeDemande.poste || "Poste"}

📍 Localisation : Casablanca, Maroc
💼 Type de contrat : ${safeDemande.typeEmploi || "CDI"}
📚 Niveau requis : ${safeDemande.niveauxEtudes || "Bac+5"}
⏳ Expérience : ${safeDemande.anneesExperience || "2+ ans"}

📝 Description du poste :
${safeDemande.description || "Nous recherchons un profil motivé et compétent."}

🔍 Profil recherché :
${safeDemande.profileRecherche || "Candidat dynamique avec esprit d'équipe"}

🏫 Établissement préféré : ${safeDemande.etabliseement || "Tous établissements"}

📧 Pour postuler, envoyez votre CV à : recrutement@entreprise.ma

✨ Rejoignez notre équipe et participez à notre croissance !`;

        setAnnonceText(text);
        setActiveTab(1);
    };

    const handlePublish = () => {
        const selectedPlatforms = Object.keys(platforms).filter((p) => platforms[p]);

        if (selectedPlatforms.length === 0) {
            Swal.fire({
                icon: "warning",
                text: "Veuillez sélectionner au moins une plateforme",
                timer: 2200,
                showConfirmButton: false,
            });
            return;
        }

        if (!dateDebut || !dateFin) {
            Swal.fire({
                icon: "warning",
                text: "Veuillez sélectionner les dates de début et de fin",
                timer: 2200,
                showConfirmButton: false,
            });
            return;
        }

        console.log("Publication:", {
            platforms: selectedPlatforms,
            dateDebut,
            dateFin,
            annonce: annonceText,
        });

        Swal.fire({
            icon: "success",
            text: `Annonce publiée sur ${selectedPlatforms.length} plateforme(s)`,
            timer: 2200,
            showConfirmButton: false,
        });
    };

    const toggleChasseur = (id) => {
        setSelectedChasseurs((prev) =>
            prev.includes(id) ? prev.filter((cid) => cid !== id) : [...prev, id]
        );
    };

    const toggleEcole = (id) => {
        setSelectedEcoles((prev) =>
            prev.includes(id) ? prev.filter((eid) => eid !== id) : [...prev, id]
        );
    };

    const handleSendToChasseurs = () => {
        if (selectedChasseurs.length === 0) {
            Swal.fire({
                icon: "warning",
                text: "Veuillez sélectionner au moins un chasseur de tête",
                timer: 2200,
                showConfirmButton: false,
            });
            return;
        }

        if (!dateLimiteOffre) {
            Swal.fire({
                icon: "warning",
                text: "Veuillez renseigner la date limite de l'offre",
                timer: 2200,
                showConfirmButton: false,
            });
            return;
        }

        if (!safeDemande?.id) {
            Swal.fire({
                icon: "error",
                text: "Demande de recrutement introuvable",
                timer: 2200,
                showConfirmButton: false,
            });
            return;
        }

        const payload = {
            demandeId: safeDemande.id,
            chasseurIds: selectedChasseurs,
            dateLimiteOffre,
            dateEnvoiEmail,
        };

        sendOfferToChasseurs(payload);
    };

    const handleSendToEcoles = () => {
        if (selectedEcoles.length === 0) {
            Swal.fire({
                icon: "warning",
                text: "Veuillez sélectionner au moins un partenaire académique",
                timer: 2200,
                showConfirmButton: false,
            });
            return;
        }

        if (!dateLimiteOffre) {
            Swal.fire({
                icon: "warning",
                text: "Veuillez renseigner la date limite de l'offre",
                timer: 2200,
                showConfirmButton: false,
            });
            return;
        }

        if (!safeDemande?.id) {
            Swal.fire({
                icon: "error",
                text: "Demande de recrutement introuvable",
                timer: 2200,
                showConfirmButton: false,
            });
            return;
        }

        const payload = {
            demandeId: safeDemande.id,
            partenaireIds: selectedEcoles,
            dateLimiteOffre,
            dateEnvoiEmail,
        };

        sendOfferToPartenaires(payload);
    };

    if (!open) return null;

    return (
        <div className="anModal" onMouseDown={onClose} role="dialog" aria-modal="true">
            <div className="anModal__panel" onMouseDown={(e) => e.stopPropagation()}>
                <div className="anModal__header">
                    <div className="anModal__title">
                        <Megaphone size={18} />
                        Annonce — {safeDemande.poste}
                    </div>
                    <button className="anIconBtn" onClick={onClose} aria-label="Fermer">
                        <X size={18} />
                    </button>
                </div>

                <div className="anTabs">
                    <button
                        className={`anTab ${activeTab === 0 ? "anTab--active" : ""}`}
                        onClick={() => setActiveTab(0)}
                        type="button"
                    >
                        <Megaphone size={14} />
                        Générer l'annonce
                    </button>
                    <button
                        className={`anTab ${activeTab === 1 ? "anTab--active" : ""}`}
                        onClick={() => setActiveTab(1)}
                        type="button"
                    >
                        <Eye size={14} />
                        Publier l'annonce
                    </button>
                    <button
                        className={`anTab ${activeTab === 2 ? "anTab--active" : ""}`}
                        onClick={() => setActiveTab(2)}
                        type="button"
                    >
                        <Send size={14} />
                        Chasseurs de tête
                    </button>
                    <button
                        className={`anTab ${activeTab === 3 ? "anTab--active" : ""}`}
                        onClick={() => setActiveTab(3)}
                        type="button"
                    >
                        <Send size={14} />
                        Partenaires académiques
                    </button>
                </div>

                <div className="anModal__body">
                    {activeTab === 0 && (
                        <div className="anContent">
                            <div className="anCard">
                                <div className="anCardHeader">
                                    <h3 className="anCardTitle">Informations du poste</h3>
                                </div>

                                <div className="anPreview">
                                    <p>
                                        <strong>Poste :</strong> {safeDemande.poste || "—"}
                                    </p>
                                    <p>
                                        <strong>Type d'emploi :</strong> {safeDemande.typeEmploi || "—"}
                                    </p>
                                    <p>
                                        <strong>Niveau d'études :</strong> {safeDemande.niveauxEtudes || "—"}
                                    </p>
                                    <p>
                                        <strong>Expérience :</strong> {safeDemande.anneesExperience || "—"}
                                    </p>
                                    <p>
                                        <strong>Établissement :</strong> {safeDemande.etabliseement || "—"}
                                    </p>
                                    <div className="anH4"></div>
                                    <p>
                                        <strong>Description :</strong>
                                    </p>
                                    <p>{safeDemande.description || "—"}</p>
                                    <div className="anH4"></div>
                                    <p>
                                        <strong>Profil recherché :</strong>
                                    </p>
                                    <p>{safeDemande.profileRecherche || "—"}</p>
                                </div>

                                <div className="anTextRight">
                                    <button
                                        className="anBtn anBtn--primary"
                                        onClick={generateAnnonce}
                                        type="button"
                                    >
                                        <Megaphone size={16} />
                                        Générer l'annonce
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === 1 && (
                        <div className="anContent">
                            <div className="anCard">
                                <div className="anCardHeader">
                                    <h3 className="anCardTitle">Prévisualisation de l'annonce</h3>
                                </div>

                                <textarea
                                    className="anTextarea"
                                    rows={12}
                                    value={annonceText}
                                    onChange={(e) => setAnnonceText(e.target.value)}
                                    placeholder="Cliquez sur 'Générer l'annonce' dans l'onglet précédent..."
                                />
                            </div>

                            <div className="anCard">
                                <div className="anCardHeader">
                                    <h3 className="anCardTitle">Plateformes de publication</h3>
                                </div>

                                <div className="anPlatforms">
                                    <label className="anCheckboxLabel">
                                        <input
                                            type="checkbox"
                                            className="anCheckbox"
                                            checked={platforms.linkedin}
                                            onChange={(e) =>
                                                setPlatforms({ ...platforms, linkedin: e.target.checked })
                                            }
                                        />
                                        LinkedIn
                                    </label>

                                    <label className="anCheckboxLabel">
                                        <input
                                            type="checkbox"
                                            className="anCheckbox"
                                            checked={platforms.rekrute}
                                            onChange={(e) =>
                                                setPlatforms({ ...platforms, rekrute: e.target.checked })
                                            }
                                        />
                                        Rekrute.ma
                                    </label>

                                    <label className="anCheckboxLabel">
                                        <input
                                            type="checkbox"
                                            className="anCheckbox"
                                            checked={platforms.emploi}
                                            onChange={(e) =>
                                                setPlatforms({ ...platforms, emploi: e.target.checked })
                                            }
                                        />
                                        Emploi.ma
                                    </label>
                                </div>

                                <div className="anDateSection">
                                    <div className="anField">
                                        <label>Date de début</label>
                                        <input
                                            type="date"
                                            value={dateDebut}
                                            onChange={(e) => setDateDebut(e.target.value)}
                                        />
                                    </div>

                                    <div className="anField">
                                        <label>Date de fin</label>
                                        <input
                                            type="date"
                                            value={dateFin}
                                            onChange={(e) => setDateFin(e.target.value)}
                                        />
                                    </div>

                                    <button
                                        className="anBtn anBtn--publish"
                                        onClick={handlePublish}
                                        type="button"
                                    >
                                        <Eye size={16} />
                                        Publier l'annonce
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === 2 && (
                        <div className="anContent">
                            <div className="anCard">
                                <div className="anCardHeader">
                                    <h3 className="anCardTitle">
                                        Envoyer l'annonce aux chasseurs de tête ({selectedChasseurs.length} sélectionné(s))
                                    </h3>
                                </div>

                                <div className="anTableWrap">
                                    <table className="anTable">
                                        <thead>
                                        <tr>
                                            <th style={{ width: 50 }}>
                                                <input type="checkbox" disabled />
                                            </th>
                                            {/*<th>Logo</th>*/}
                                            <th>Nom du chasseur</th>
                                            <th>Email</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {(chasseurs || []).map((chasseur) => {                                            const isSelected = selectedChasseurs.includes(chasseur.id);
                                            return (
                                                <tr key={chasseur.id}>
                                                    <td>
                                                        <input
                                                            type="checkbox"
                                                            checked={isSelected}
                                                            onChange={() => toggleChasseur(chasseur.id)}
                                                        />
                                                    </td>
                                                    {/*<td>*/}
                                                    {/*    <div className="anLogo">{chasseur.logo}</div>*/}
                                                    {/*</td>*/}
                                                    <td className="anStrong">{chasseur.nom}</td>
                                                    <td className="anMuted">{chasseur.email}</td>
                                                </tr>
                                            );
                                        })}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="anDateSection">
                                    <div className="anField">
                                        <label>Date limite de l'offre</label>
                                        <input
                                            type="date"
                                            value={dateLimiteOffre}
                                            onChange={(e) => setDateLimiteOffre(e.target.value)}
                                        />
                                    </div>

                                    <div className="anField">
                                        <label>Date d'envoi de l'email</label>
                                        <input
                                            type="date"
                                            value={dateEnvoiEmail}
                                            onChange={(e) => setDateEnvoiEmail(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="anTextRight">
                                    <button
                                        className="anBtn anBtn--send"
                                        onClick={handleSendToChasseurs}
                                        disabled={selectedChasseurs.length === 0 || sendingOfferToChasseurs}
                                        type="button"
                                    >
                                        <Send size={16} />
                                        {sendingOfferToChasseurs
                                            ? "Envoi..."
                                            : "Envoyer aux chasseurs sélectionnés"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === 3 && (
                        <div className="anContent">
                            <div className="anCard">
                                <div className="anCardHeader">
                                    <h3 className="anCardTitle">
                                        Envoyer l'annonce aux partenaires académiques ({selectedEcoles.length} sélectionné(s))
                                    </h3>
                                </div>

                                <div className="anTableWrap">
                                    <table className="anTable">
                                        <thead>
                                        <tr>
                                            <th style={{ width: 50 }}>
                                                <input type="checkbox" disabled />
                                            </th>
                                            {/*<th>Logo</th>*/}
                                            <th>Nom du partenaire</th>
                                            <th>Type</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {partenaires.map((ecole) => {
                                            const isSelected = selectedEcoles.includes(ecole.id);
                                            return (
                                                <tr key={ecole.id}>
                                                    <td>
                                                        <input
                                                            type="checkbox"
                                                            checked={isSelected}
                                                            onChange={() => toggleEcole(ecole.id)}
                                                        />
                                                    </td>
                                                    {/*<td>*/}
                                                    {/*    <div className="anLogo anLogo--school">{ecole.logo}</div>*/}
                                                    {/*</td>*/}
                                                    <td className="anStrong">{ecole.nom}</td>
                                                    <td className="anMuted">{ecole.email}</td>
                                                </tr>
                                            );
                                        })}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="anDateSection">
                                    <div className="anField">
                                        <label>Date limite de l'offre</label>
                                        <input
                                            type="date"
                                            value={dateLimiteOffre}
                                            onChange={(e) => setDateLimiteOffre(e.target.value)}
                                        />
                                    </div>

                                    <div className="anField">
                                        <label>Date d'envoi de l'email</label>
                                        <input
                                            type="date"
                                            value={dateEnvoiEmail}
                                            onChange={(e) => setDateEnvoiEmail(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="anTextRight">
                                    <button
                                        className="anBtn anBtn--send"
                                        onClick={handleSendToEcoles}
                                        disabled={selectedEcoles.length === 0 || sendingOfferToPartenaires}
                                        type="button"
                                    >
                                        <Send size={16} />
                                        {sendingOfferToPartenaires
                                            ? "Envoi..."
                                            : "Envoyer aux partenaires sélectionnés"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    sendingOfferToChasseurs: state.demandesRecrutement?.sendingOfferToChasseurs || false,
    sendingOfferToPartenaires: state.demandesRecrutement?.sendingOfferToPartenaires || false,
    sendOfferSuccess: state.demandesRecrutement?.sendOfferSuccess || "",
    sendOfferError: state.demandesRecrutement?.sendOfferError || null,
});

const mapDispatchToProps = (dispatch) => ({
    sendOfferToChasseurs: (payload) =>
        dispatch(sendOfferToChasseursRequest(payload)),
    sendOfferToPartenaires: (payload) =>
        dispatch(sendOfferToPartenairesRequest(payload)),
    clearRecrutementEmailState: () =>
        dispatch(clearRecrutementEmailState()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AnnonceModal);